// import React from "react";
// import * as FaIcons from "react-icons/fa";
// import * as AiIcons from "react-icons/ai";
// import * as IoIcons from "react-icons/io";

// export const SidebarData = [
//   {
//     title: "Dashboard",
//     path: "/home",
//     icon: <AiIcons.AiFillAppstore />,
//     cName: "nav-text",
//   },
//   {
//     title: "Company",
//     path: "/companies",
//     icon: <AiIcons. AiFillContainer />,
//     cName: "nav-text",
//   },
//   {
//     title: "Devices",
//     path: "/devices",
//     icon: <IoIcons.IoIosPaper />,
//     cName: "nav-text",
//   },
//   {
//     title: "Machine",
//     path: "/machine",
//     icon: <FaIcons.FaTv />,
//     cName: "nav-text",
//   },
//   {
//     title: "User",
//     path: "/user",
//     icon: <IoIcons.IoMdPerson />,
//     cName: "nav-text",
//   }
// ];

import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";

import { getUserDetails } from '../Utility/AsyncStorage';

const SidebarDataSM = [
  { title: "Dashboard", path: "/home", icon: <AiIcons.AiFillAppstore />, cName: "nav-text" },
  { title: "Company", path: "/companies", icon: <AiIcons.AiFillContainer />, cName: "nav-text" },
  { title: "Devices", path: "/devices", icon: <IoIcons.IoIosPaper />, cName: "nav-text" },
  { title: "Machine", path: "/machine", icon: <FaIcons.FaTv />, cName: "nav-text" },
  { title: "User", path: "/user", icon: <IoIcons.IoMdPerson />, cName: "nav-text" }
];

const SidebarDataA = [
  { title: "Dashboard", path: "/home", icon: <AiIcons.AiFillAppstore />, cName: "nav-text" },
  { title: "Devices", path: "/devices", icon: <IoIcons.IoIosPaper />, cName: "nav-text" },
  { title: "Machine", path: "/machine", icon: <FaIcons.FaTv />, cName: "nav-text" },
  { title: "User", path: "/user", icon: <IoIcons.IoMdPerson />, cName: "nav-text" }
];

export const SidebarData = [];

export const fetchSidebarData = async () => {
  const userdetail = await getUserDetails();
  if (userdetail?.role !== "ADMIN") {
    SidebarData.length = 0;
    SidebarData.push(...SidebarDataSM);
  } else {
    SidebarData.length = 0;
    SidebarData.push(...SidebarDataA);
  }
};

